export const RestMethod = Object.freeze({
    saleEntityAddBasketItem: 'addBasketItem',
    saleEntityUpdateBasketItem: 'updateBasketItem',
    saleEntityDeleteBasketItem: 'deleteBasketItem',
    saleEntityRecalculateBasket: 'recalculateBasket',
    saleEntityGetBasket: 'getBasket',
    saleEntityUserConsentRequest:'userconsentrequest',
    saleEntitySaveOrder: 'saveOrder',
    saleEntityPaymentPay: 'paymentpay'
});